import useTranslator from "../../hooks/useTranslator";
import { ProgressRail, StepList } from "../../components/design";

const TenantChecksSidebar = ({ visibleSteps, activeId }) => {
  const { _t } = useTranslator();
  const sidebarSteps = visibleSteps
    .filter((s) => !s.hideInSidebar)
    .map((s) => ({ id: s.id, title: _t(s.titleKey, s.fallback) }));
  // -1 when the current step is not in the list: no step is highlighted
  // (ProgressRail falls back to the first step for its caption and phone label)
  const activeIndex = sidebarSteps.findIndex((s) => s.id === activeId);

  return (
    <ProgressRail
      label={_t("yourProcess", "Your process")}
      steps={sidebarSteps}
      activeIndex={activeIndex}
    >
      <p className="onboarding-progress__eyebrow">
        {_t("yourProcess", "Your process")}
      </p>
      <StepList
        steps={sidebarSteps}
        activeIndex={activeIndex}
        completedLabel={_t("completed", "Completed")}
      />
    </ProgressRail>
  );
};

export default TenantChecksSidebar;
